module.exports = __webpack_public_path__ + "static/media/France_Poland.072b01ad.jpeg";